import { render, staticRenderFns } from "./AudioToText.vue?vue&type=template&id=084c6006&scoped=true"
import script from "./AudioToText.vue?vue&type=script&lang=js"
export * from "./AudioToText.vue?vue&type=script&lang=js"
import style0 from "./AudioToText.vue?vue&type=style&index=0&id=084c6006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c6006",
  null
  
)

export default component.exports